<template>
  <footer>
      <div class="footer-links">
        <router-link to="/game-guide">Game Guide</router-link>
        <router-link to="/privacy-policy">Privacy Policy</router-link>
        <router-link to="/terms">Terms of Service</router-link>
        <router-link to="/disclaimer">Disclaimer</router-link>
        <router-link to="/about">About Us</router-link>
        <router-link to="/contact">Contact Us</router-link>
      </div>
    <p>&copy; {{ currentYear }} ArcadeJoy. All rights reserved.</p>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
footer {
  margin-top: 40px;
  padding: 20px 0;
  text-align: center;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 10px;
}

.footer-links a {
  color: #4a90e2;
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-links a:hover {
  color: #3182ce;
  text-decoration: underline;
}
</style>